import { render, staticRenderFns } from "./display-field-discount-rule.vue?vue&type=template&id=067c9964&scoped=true&"
import script from "./display-field-discount-rule.ts?vue&type=script&lang=ts&"
export * from "./display-field-discount-rule.ts?vue&type=script&lang=ts&"
import style0 from "./display-field-discount-rule.scss?vue&type=style&index=0&id=067c9964&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067c9964",
  null
  
)

export default component.exports